"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWrenchClockFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22 31a7 7 0 117-7 7 7 0 01-7 7zm2.42-6L23 23.59V21h-2v3.41l2 2zM25 6.66l-.4-1.56-4.25 4.21c-.5.49-.66.49-.88.49a3.36 3.36 0 01-1.92-1.19 3.3 3.3 0 01-1.15-2c0-.24 0-.41.51-.9l4.21-4.17-1.54-.34A6.77 6.77 0 0013.13 3l-.06.05c-2.74 2.71-2.45 5.3-1.62 7.09L4 17.57A3.16 3.16 0 003.9 22a3.13 3.13 0 002.23 1 3.15 3.15 0 002.22-.91l7.45-7.36h.06c2.45 1.15 4.84.61 7.11-1.6a7.06 7.06 0 002.12-5A6.49 6.49 0 0025 6.66z" })));
}
exports.default = SvgWrenchClockFilled;
//# sourceMappingURL=WrenchClockFilled.js.map